import React from 'react';
import { Box, Button, IconButton, useTheme } from '@mui/material';
import { useTranslation } from 'services/localization';
import Spinner from 'common/components/Spinner';
import { RiCloseCircleFill } from 'react-icons/ri';

export interface Props {
	value?: string | null;
	onImageUpload: (value: React.ChangeEvent<HTMLInputElement>) => void;
	onDelete: () => void;
	loading: boolean;
	padding?: number;
	objectFit: 'cover' | 'contain';
}
const ImageContainer = (props: Props) => {
	const { value, onImageUpload, onDelete, loading, padding, objectFit } = props;

	const { t } = useTranslation();
	const theme = useTheme();

	return !!value ? (
		<Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
			<Box p={padding ?? 0} sx={{ width: '100%', height: '100%' }}>
				<img style={{ width: '100%', height: '100%', objectFit }} src={value} alt="" />
			</Box>
			<IconButton
				sx={{
					position: 'absolute',
					top: 0,
					right: 0,
				}}
				onClick={onDelete}
			>
				<RiCloseCircleFill size={16} color={theme.palette.secondary.main} />
			</IconButton>
		</Box>
	) : loading ? (
		<Spinner relative />
	) : (
		<Button component="label" variant="contained">
			{t('common:actions.addImage', 'Add image')}
			<input type="file" name="file" hidden onChange={onImageUpload} />
		</Button>
	);
};

export default ImageContainer;
